import React from 'react';
import CandidateCard from './CandidateCard';
import { Grid } from '@/Components/ui/layout';

function CandidateList() {
  const candidates = Array(6).fill({
    name: 'Ronald Richards',
    role: 'UI/UX Designer',
    experience: '7 Years Experience',
    education: 'Master Degree',
    appliedDate: 'Jan 23, 2022'
  });

  return (
    <div className="flex flex-wrap gap-[208px] flex-1 ml-[10%] -mt-20">
      {candidates.map((candidate, index) => (
        <CandidateCard key={index} {...candidate} />
      ))}
    </div>
  );
}

export default CandidateList;